<template>
    <div class="counpon" v-for="item in couponlist" @click="go(item)">
        <span class="name">{{item.name}}</span>
        <span class="price" v-if="item.price">
            <b>{{item.price}}</b>元</span>
        <span class="price" v-if="item.discount">
            <!-- <i>￥</i> -->
            <b>{{item.discount}}</b>折</span>
        <span class="date">{{item.starttime | filterTime}}-{{item.endtime | filterTime}}</span>
        <span class="btn" v-if="item.url">去使用</span>
        <!-- <img src="//static.daojia.com/fe/jz/daojiaapp/hongbao/image/coupon.e8978c7b.png" alt=""> -->
        <img src="//static.djtest.cn/fe/other/lx20170226/newcoupon/img/coupon.png" alt="">
        <div class="img-shade"></div>
    </div>
</template>
<script>
import utils from '@/tools/utils.js'
import {trackAction} from '@/tools/track.js'
export default {
    props: {
        couponlist: Array
    },
    filters: {
        filterTime(time) {
            var ymd = time.split(' ')[0];
            return ymd.replace(/\//g, '.');
        }
    },
    methods: {
        go(item) {
            let url = item.url   // 开发先注释
            // let url = 'https://tjzt74.djtest.cn/h5/thirdPartyBj/xiaoshigong?&serviceType=1002223&lng=&phone=&location=&lat=&cityid=483#/index'   // 写死一个url
            // window.trackClick(`activity_${item.batchId}`)
            trackAction({
                'page_type': 'bjhongbao_coupon',
                'page_name': 'bjhongbao_coupon_bind_success',
                'event_id': 'click_order_now',
                'templateid': utils.urlParam('templateid')
            })
            if(url){
                //非微信环境逻辑
                var reg = /^daojia:.+/.test(url)
                var currUrl;
                if (window.isAppFlag && !reg) {
                    currUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(url);
                }else{
                    currUrl = url
                }
                location.href = currUrl
            }
            // 适配小程序环境
            // let ua = window.navigator.userAgent.toLowerCase();
            // if(ua.match(/MicroMessenger/i) == 'micromessenger'){    //判断是否是微信环境
            //     //微信环境
            //     wx.miniProgram.getEnv(function(res) {
            //         if (res.miniprogram) {
            //             // 小程序环境下逻辑 
            //             console.log('小程序环境')
            //             wx.miniProgram.navigateTo({url: url})
            //         }else {
            //             //微信非小程序环境下逻辑
            //             if(url){
            //                 //非微信环境逻辑
            //                 var reg = /^daojia:.+/.test(url)
            //                 var currUrl;
            //                 if (window.isAppFlag && !reg) {
            //                     currUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(url);
            //                 }else{
            //                     currUrl = url
            //                 }
            //                 location.href = currUrl
            //             }
            //         }
            //     })
            // }else{
            //     if(url){
            //         //非微信环境逻辑
            //         var reg = /^daojia:.+/.test(url)
            //         var currUrl;
            //         if (window.isAppFlag && !reg) {
            //             currUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(url);
            //         }else{
            //             currUrl = url
            //         }
            //         location.href = currUrl
            //     }
            // }
        }
    }
}
</script>


// WEBPACK FOOTER //
// Success.vue?ebf896f4